import React from 'react'
import { Flex, Border, Text, Button } from 'rebass'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import leftPad from 'left-pad'

import AutoSuggest from '../elements/AutoSuggest'
import { Creatable as Select } from 'react-select'
import 'react-select/dist/react-select.css'
import Page, { Container } from '../elements/Page'
import { taskType, rowNumber, changeGh, endTask } from '../model/actions'
import { getTimeDisplay } from '../lib/time'
import { Label, Input } from '../elements/Form.js'

const Blue = styled.span`
  color: #4a90e2;
`

const EmptyState = () => {
  return (
    <Text m={4} f={4} color="#3f3e3e">
      Task not found. You should{' '}
      <Blue>
        <Link to="/tasks">go back</Link>
      </Blue>.
    </Text>
  )
}

const Clock = styled.div`
  font-family: Menlo, Monospace;
  font-size: 50px;
  margin-bottom: 20px;
  ${'' /* align-self: center; */};
`

class TasksView extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      time: Date.now(),
    }
  }
  tick = () => {
    this.setState({ time: Date.now() })
  }
  componentDidMount() {
    this.timer = setInterval(this.tick, 100)
  }
  componentWillUnmount() {
    clearInterval(this.timer)
  }
  changeType = newTypes => {
    this.props.taskType(
      this.props.match.params.task,
      newTypes.map(type => type.value),
    )
  }
  changeRow = e => {
    this.props.rowNumber(this.props.match.params.task, Number(e.target.value))
  }
  changeGh = e => {
    this.props.changeGh(this.props.match.params.task, Number(e.target.value))
  }
  end = () => {
    this.props.endTask(this.props.match.params.task)
  }
  render() {
    const { task, history } = this.props

    const taskSuggestions = this.props.taskSuggestions
      .map(t => ({
        label: t,
        value: t,
      }))
      .toArray()

    return (
      <Page title="Edit task" onBack={() => history.push('/tasks')}>
        {(() => {
          if (typeof this.props.task === 'undefined') {
            return <EmptyState />
          }
          return (
            <Container>
              <Clock>
                {getTimeDisplay(
                  task.get('startDate'),
                  task.get('endDate', this.state.time),
                )}
              </Clock>
              <Input>
                <Label>What are you doing?</Label>
                <Select
                  value={task.get('type').toArray()}
                  onChange={this.changeType}
                  options={taskSuggestions}
                  placeholder="Select a task..."
                  multi
                  closeOnSelect={false}
                />
              </Input>
              <Input>
                <Label>Which Greenhouse?</Label>
                <input
                  type="number"
                  value={task.get('greenhouse') || ''}
                  onChange={this.changeGh}
                />
              </Input>
              <Input>
                <Label>What Row Number?</Label>
                <input
                  type="number"
                  value={task.get('row') || ''}
                  onChange={this.changeRow}
                />
              </Input>
              {task.get('endDate') ? (
                'This task has ended.'
              ) : (
                <Button onClick={this.end}>End Task</Button>
              )}
            </Container>
          )
        })()}
      </Page>
    )
  }
}

const mapState = (state, ownProps) => {
  return {
    task: state.data.getIn(['tasks', ownProps.match.params.task]),
    taskSuggestions: state.data.get('taskSuggestions'),
  }
}

const eventMap = {
  taskType,
  rowNumber,
  changeGh,
  endTask,
}

export default connect(mapState, eventMap)(withRouter(TasksView))



// WEBPACK FOOTER //
// ./src/Tasks/EditTask.js